import React from 'react';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../hooks/useLanguage';
import { serviceAreas } from '../data/serviceAreas';
import { business } from '../data/business';
import { ui } from '../data/translations';
export function ServiceAreas() {
  const {
    t
  } = useLanguage();
  return <section id="areas" className="w-full bg-navy py-20 lg:py-24" data-id="element-188" data-mp="2pqu580m5ktbl">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8" data-id="element-189" data-mp="2brug6ruqacew">
        <div data-id="element-190" data-mp="2gr70b4u7t5ds">
          <h2 className="font-display text-3xl font-bold leading-tight text-white lg:text-4xl" data-id="element-191" data-mp="2grqkytb927vi">{t(ui.areas.title)}</h2>
          <p className="mt-4 text-white/70" data-id="element-192" data-mp="22t0nvdofk875">{t(ui.areas.subtitle)}</p>
          <p className="mt-10 text-white" data-id="element-193" data-mp="26srcbaqhic8i">{t(ui.areas.cta)}</p>
          <a href={business.phoneHref} className="mt-4 inline-flex h-14 items-center gap-3 whitespace-nowrap rounded-md bg-gold px-6 font-display text-lg font-bold text-navy-deep transition-colors duration-150 hover:bg-gold-dark" data-id="element-194" data-mp="26vdkncl78vrs">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-195" data-mp="68pxtuvlmmm3" />
            {business.phoneDisplay}
          </a>
        </div>

        <ul className="grid content-center gap-x-8 sm:grid-cols-2" data-id="element-196" data-mp="18v7ptjne123">
          {serviceAreas.map(area => <li key={area.en} className="flex items-center gap-3 border-b border-white/15 py-4 text-white" data-id="element-197" data-mp="g1onzh6qul7t">
              <MapPinIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-198" data-mp="3jgkqlvn3lot6" />
              {t(area)}
            </li>)}
        </ul>
      </div>
    </section>;
}